// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bfw_a"};